import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Specialties from '../components/Specialties';
import Services from '../components/Services';
import Experience from '../components/Experience';
import Certifications from '../components/Certifications';
import Testimonials from '../components/Testimonials';
import Publications from '../components/Publications';
import Gallery from '../components/Gallery';
import Appointment from '../components/Appointment';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import Header from '../components/Header';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <About />
      <Specialties />
      <Services />
      <Experience />
      <Certifications />
      <Testimonials />
      <Publications />
      <Gallery />
      <Appointment />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;